import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "version" }

import versionInfo from '@/version.json';
import { Version } from '@/models/version.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'Version',
  setup(__props) {

const version = new Version(versionInfo);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, "Version " + _toDisplayString(_unref(version).version), 1))
}
}

})